'use strict';
/* eslint no-sync: 0 */

const INDENT = String.fromCharCode(160) + String.fromCharCode(160);

import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';

export class CategorySelectComponent {

  Storage;
  categories = [];
  list = [];
  tree = {};
  rootParentId = undefined;

  constructor(Storage, Auth) {
    'ngInject';

    this.Storage = Storage;
    this.getCurrentUser = Auth.getCurrentUser;
  }

  _buildOptions(category, depth) {
    depth = depth || '';

    if(category._id){
      category.indent = depth;
      this.categories.push(category);
    }

    (category.childs || []).forEach((child) => this._buildOptions(child, depth + INDENT));
  }

  _buildTree(category) {
    category.childs = [];

    this.list.forEach(child => {

      if(category._id != child.parentId){
        return;
      }

      child = this._buildTree(child);

      category.childs.push(child);
    });

    return category;
  }

  _searchParent(category) {
    // this is real root
    if(category.parentId == undefined){
      return category;
    }

    // search root of parent tree
    var parent = this.list.filter((g) => {
      return g._id == category.parentId;
    }).shift();

    // no parent, could be is not allowed for current user
    // so return it self
    if( ! parent){
      return category;
    }

    // go next
    return this._searchParent(parent);
  }

  updateTree(categories) {
    
    // set categories
    if(categories){
      this.list = categories;
    }

    // clear selec
    this.categories = [];
    this.three = {};

    var roots = [];
    (this.list || []).forEach((category) => roots.push(this._searchParent(category)));

    roots = roots.filter((category1, index, self) => {
      var find = -1;
      self.forEach((category2, i) => {
        if(category1._id == category2._id){
          find = i;
          return false;
        }
      });
      return (find === index);
    }).map((category) => this._buildTree(category));

    this._buildOptions({
      name: 'Корень',
      childs: roots
    });
  }

  $onInit() {
    this.updateTree(this.Storage.getCategories());
  }

  onAdd(category){
    this.ngModel = category._id;
  }

  clear() {
    this.ngModel = undefined;
  }
}

export default angular.module('ascuteApp.form.element.category', [uiBootstrap])
  .component('categorySelect', {
    bindings: {
      ngModel: '=', 
      ngRequired: '=',
      title: '=',
      allowAddon: '=',
      moduleId: '=',
      raw: '=',
      noStyle: '='
    },
    template: require('./select.html'),
    controller: CategorySelectComponent,
    transclude: true
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/form/element/category/select.js